import React, { useCallback, useEffect, useRef } from "react";
import styled from "styled-components";
import { CircularProgress } from "@material-ui/core";
import Perfil from "../../../assets/icons/perfil.svg";
import CheckboxIcon from "../../../assets/icons/checkbox.svg";
import { getPermission, handlePaciente } from "../../../utils/funcs";
import { useDispatch, useSelector } from "react-redux";
import { DashBoardActions, PACIENTES_PAGE_SIZE } from "../../../store/ducks/dashboard";
import { PacientesProps, UserProps } from "../../../interfaces/pacientes.interface";
import { getEtiquetas } from "../../../utils/etiquetas";
import { PacAvalActions } from "../../../store/ducks/manage_pac_aval";
import { AppActions } from "../../../store/ducks/app";
import moment from "moment";
import { Checkbox } from "../../../styles/global";
import history from "../../../routes/history";
import { AddPacAvalActions } from "../../../store/ducks/add_pac_aval";
import { AmplitudeLog, getUserEmailAndUserPhone } from "../../../utils/amplitude";
import { ServicosProps } from "../../../interfaces/config.interface";
import { TypesPermission } from "../../../utils/types";
import { ConfigsActions } from "../../../store/ducks/configs";
import { TextsProps } from "../../../database/txt.interface";
import { AtribuirActions } from "../../../store/ducks/atribuir";
import { AnamneseActions } from "../../../store/ducks/anamnese";
import { P2Desk } from "../../../styles/styles_text";
import Loading from "../Loading";
import { loadStorage } from "../../../utils/base_async_storage";
import { AvaliationActions } from "../../../store/ducks/avaliation";
import { AnswerNpsProps } from "../../../store/models";
import { RelatorioActions } from "../../../store/ducks/relatorios";
import ModalNPS from "../../../components/Modais/ModalNPS";
import { useDataSubscription } from "../../../hooks/useDataSubscription";

const ListagemPacientes: React.FC = () => {
	const dispatch = useDispatch();
	const { hasLoadedSubscription, hasServiceWorklab } = useDataSubscription();
	const hasRequestedIcp = useRef(false);
	const listRef = useRef<HTMLDivElement>(null);
	const patientsItemRef = useRef<HTMLDivElement>(null);
	const isLoadingMorePatientsRef = useRef(false);
	const wasLoadingMoreRef = useRef(false);
	const search = useSelector((state: any) => state.dashboard.search);

	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);
  const user_logado: UserProps = useSelector((state: any) => state.auth.user);
	const etis = useSelector((state: any) => state.dashboard.etiquetas);
	const lista_filtro = useSelector((state: any) => state.app.lista_filtro);

	const pacientes = useSelector((state: any) => state.dashboard.pacientes);

	const button_search = useSelector(
		(state: any) => state.dashboard.button_search
	);

	const option = useSelector(
		(state: any) => state.atribuir.menu_option_selected
	);

	const config_servicos = useSelector(
		(state: any) => state.configs.config_servicos
	);

	const pacientes_selecionados = useSelector(
		(state: any) => state.app.lista_pacientes
	);

	const pacientes_loading = useSelector(
		(state: any) => state.dashboard.pacientes_loading
	);
	const pacientes_loading_more = useSelector(
		(state: any) => state.dashboard.pacientes_loading_more
	);
	const pacientes_has_more = useSelector(
		(state: any) => state.dashboard.pacientes_has_more
	);
	const total_pacientes = useSelector(
		(state: any) => state.dashboard.total_pacientes
	);
	const pacientes_next_offset = useSelector(
		(state: any) => state.dashboard.pacientes_next_offset
	);
	const history_icp = useSelector(
		(state:any) => state.avaliation.data_history_icp,
	);
	const modalVisible: boolean = useSelector((state: any) => state.app.modal_promo_visible);

	const HandleClassUsuario = (val: PacientesProps, event: any) => {
		event.stopPropagation();
		let aux_lista_pacientes = pacientes_selecionados;

		const exists = pacientes_selecionados.includes(val.ID_USUARIO);

		if (exists) {
			aux_lista_pacientes = aux_lista_pacientes.filter(
				(id: number) => id != val.ID_USUARIO
			);
		} else {
			aux_lista_pacientes = [...aux_lista_pacientes, val.ID_USUARIO];
		}

		dispatch(AppActions.set_lista_pacientes(aux_lista_pacientes));
	};

	const selecionarTodos = () => {
		const aux_pacientes_selecionados: any = [];
		pacientes?.map((val: PacientesProps) => {
			aux_pacientes_selecionados.push(val.ID_USUARIO);
		});
		dispatch(AppActions.set_lista_pacientes(aux_pacientes_selecionados));
	};

	const PesquisarPaciente = () => {
		const filtros_paginacao = {
			inicio: 0,
			fim: PACIENTES_PAGE_SIZE,
			filtros: [
				{ tipo: "USUARIO_EXCLUIDO", valor: "N" },
				{ tipo: "USUARIO_NIVEL", valor: [3] },
			],
		};

		if (search != "") {
			filtros_paginacao.filtros.push({ tipo: "USUARIO_NOME", valor: search });
		}

		dispatch(DashBoardActions.set_filtros_pacintes_request(filtros_paginacao));
		dispatch(DashBoardActions.paciente_request());
	};

	const loadMorePatients = useCallback(() => {
		if (
			isLoadingMorePatientsRef.current ||
			button_search ||
			pacientes_loading ||
			pacientes_loading_more ||
			!Array.isArray(pacientes) ||
			pacientes.length === 0
		) {
			return;
		}

		if (pacientes_has_more === false) {
			return;
		}

		if (total_pacientes > 0 && pacientes.length >= total_pacientes) {
			return;
		}

		const inicio = pacientes_next_offset;
		isLoadingMorePatientsRef.current = true;
		dispatch(
			DashBoardActions.paciente_request({
				append: true,
				inicio,
				fim: inicio + PACIENTES_PAGE_SIZE,
			})
		);
	}, [
		button_search,
		dispatch,
		pacientes,
		pacientes_has_more,
		pacientes_loading,
		pacientes_loading_more,
		pacientes_next_offset,
		total_pacientes,
	]);

	const handleListScroll = (event: React.UIEvent<HTMLDivElement>) => {
		const target = event.currentTarget;
		const distanceToBottom =
			target.scrollHeight - target.scrollTop - target.clientHeight;

		if (distanceToBottom <= 80) {
			loadMorePatients();
		}
	};

	const OpenPaci = (paciente: PacientesProps) => {
		handlePaciente(paciente, dispatch,config_servicos );
		dispatch(AtribuirActions.set_menu_option_selected(""));
		dispatch(AppActions.set_lista_pacientes([]));
		dispatch(DashBoardActions.set_current_page("perfil_paciente"));
	};

	useEffect(() => {
		if (button_search) {
			PesquisarPaciente();
		}
	}, [button_search]);

	useEffect(() => {
		if (button_search) {
			isLoadingMorePatientsRef.current = false;
		}
	}, [button_search]);

	useEffect(() => {
		if (wasLoadingMoreRef.current && !pacientes_loading_more) {
			isLoadingMorePatientsRef.current = false;
		}
		wasLoadingMoreRef.current = !!pacientes_loading_more;
	}, [pacientes_loading_more]);

	useEffect(() => {
		const root = listRef.current;
		const patientItems = patientsItemRef.current;
		if (!root || !patientItems || button_search || pacientes_loading) {
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				if (entries.some((entry) => entry.isIntersecting)) {
					loadMorePatients();
				}
			},
			{
				root,
				rootMargin: "80px",
				threshold: 0,
			}
		);

		observer.observe(patientItems);
		return () => observer.disconnect();
	}, [button_search, loadMorePatients, pacientes, pacientes_loading]);

	useEffect(() => {
		if (
			!hasRequestedIcp.current &&
			hasLoadedSubscription &&
			!hasServiceWorklab &&
			!config_servicos?.SERVICO_DYNALAB
		) {
			hasRequestedIcp.current = true;
			dispatch(AvaliationActions.set_request_history_icp());
		}
	}, [
		config_servicos?.SERVICO_DYNALAB,
		dispatch,
		hasLoadedSubscription,
		hasServiceWorklab,
	]);

	useEffect(() => {
		if(config_servicos?.SERVICO_DYNALAB){
			dispatch(RelatorioActions.sync_last_report_emission())
			dispatch(DashBoardActions.avaliacoes_request())
			dispatch(DashBoardActions.assimetrias_dynalabs_request())
		}
		getUserEmailAndUserPhone(user_logado.USUARIO_EMAIL, user_logado.USUARIO_CONTATO)
	}, [])

	// const npsAnswered = useSelector((state:any)=> state.app.answered_nps)
	// const dataNpsAnswered:Array<AnswerNpsProps> = useSelector((state:any)=> state.app.data_answered_nps)

	// useEffect(()=>{
	// 	if(!config_servicos?.SERVICO_DYNALAB) {
	// 		const today = moment(new Date()).format('DD-MM-YYYY').toString();
	// 		loadStorage('modalNps')
	// 			.then((lastViwerNps)=>{
	// 				if(npsAnswered != null
	// 					&& lastViwerNps != today 
	// 					&& user_logado
	// 					&& !modalVisible
	// 				){
	// 					if(!npsAnswered){
	// 						dispatch(AppActions.set_modal_nps(true))
	// 					}
	// 				}
	// 			})
	// 			.catch(()=>{})	
	// 	}
	// },[npsAnswered, modalVisible])

	return (
		<Container>
			{option != "" && (
				<DivSelectAll>
					{pacientes_selecionados.length > 0 ? (
						<SelectAllButton
							onClick={() => dispatch(AppActions.set_lista_pacientes([]))}
						>
							{current_language?.cancelar_selecao}
						</SelectAllButton>
					) : (
						<SelectAllButton onClick={selecionarTodos}>
							{current_language?.selecionar_todos} ({pacientes.length}){" "}
						</SelectAllButton>
					)}
				</DivSelectAll>
			)}
			<PatientListContainer ref={listRef} onScroll={handleListScroll}>
				{button_search || pacientes_loading ? (
					<Loading />
				) : (
					<>
						{pacientes.map((paciente: PacientesProps) => (
							<PatientSection
								onClick={() => OpenPaci(paciente)}
								color={
									pacientes_selecionados.some(
										(id: number) => id === paciente.ID_USUARIO
									)
										? "#DEDFE3"
										: "transparent"
								}
								key={paciente.ID_USUARIO}
							>
								<ProfilePicture
									src={paciente?.USUARIO_FOTO ? paciente?.USUARIO_FOTO : Perfil}
								/>
								<NameAndTagContainer>
									<Name>{paciente.USUARIO_NOME}</Name>
									<DivTags>
										{getEtiquetas(paciente, etis, lista_filtro).map((e: any) => (
											<Tag key={e.ID_ETIQUETA}>{e.ETIQUETA_NOME}</Tag>
										))}
									</DivTags>
								</NameAndTagContainer>

								{option != "" && (
									<Checkbox
										className="custom-checkbox"
										id={paciente.ID_USUARIO.toString()}
										type="checkbox"
										src={CheckboxIcon}
										onClick={(event) => HandleClassUsuario(paciente, event)}
										checked={pacientes_selecionados.some(
											(id: number) => id === paciente.ID_USUARIO
										)}
									/>
								)}
							</PatientSection>
						))}
						<PaginationPatientItems ref={patientsItemRef}>
							{pacientes_loading_more && <CircularProgress size={24} />}
						</PaginationPatientItems>
					</>
				)}
			{/* <ModalNPS /> */}
			</PatientListContainer>
		</Container>
	);
};

const Container = styled.div`
	width: 60%;
	margin-top: 2vh;
	height: 100%;
`;

const DivSelectAll = styled.div`
	width: 100%;
	height: 7%;
	display: flex;
	justify-content: flex-end;
`;

const SelectAllButton = styled.button`
	font-family: "NotoSans-regular";
	font-size: 75%;
	font-weight: 600;
	line-height: 24.52px;
	text-align: right;
	background-color: transparent;
	border: none;
	color: #00a377;
`;

const PatientListContainer = styled.div`
	width: 100%;
	height: 55vh;
	margin-bottom: 1.5rem;
	overflow-y: scroll;
	::-webkit-scrollbar {
		width: 10px;
	}
	::-webkit-scrollbar-thumb {
		background: #e0e0e0;
		border-radius: 10px;
	}
	::-webkit-scrollbar-track {
		background: #ffffff;
		border-radius: 10px;
	}
`;

const PaginationPatientItems = styled.div`
	width: 100%;
	min-height: 1px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0.5rem 0 1rem;
`;

const PatientSection = styled.div`
	width: 100%;
	height: 4rem;
	display: flex;
	flex-direction: row;
	align-items: center;
	border-radius: 12px;
	margin-bottom: 1rem;
	padding-left: 0.5rem;
	padding-right: 1rem;
	justify-content: space-between;
	background-color: ${(props) => props.color || "transparent"};
	cursor: pointer;
`;

const ProfilePicture = styled.img`
	object-fit: cover;
	width: 2rem;
	height: 2rem;
	background-color: #ededed;
	border: 0;
	border-radius: 100%;
	box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.08);
`;

const NameAndTagContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	margin-left: 10px;
`;

const Name = styled.text`
	font-size: 1rem;
	font-family: "NotoSans-Regular";
	font-weight: 500;
	line-height: 25px;
	color: #323d6e;
`;

const DivTags = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
`;

const Tag = styled.div`
	background-color: #d0d9ff;
	border-radius: 30px;
	margin-right: 5px;
	height: 1.2rem;
	font-size: 0.8rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: 7px;
	display: flex;
	align-items: center;
	color: #323d6e;
`;

export default ListagemPacientes;

